<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet daily-engagements-card"
>
	<div class="cards-holder devices-tab">
		<div class="card card2 mRight daily-engagements">
			<app-datatable-v3
				[sectiontitle]="sectiontitle"
				[datatableconfig]="devicedatatableconfig"
				[key]="key"
				[isVerticalScrollable]="true"
				[rowHeight]="50"
				[columnsconfig]="columns"
				[queryorderby]="queryorderby"
				[defaultsort]="true"
				[downloadcsvcolumns]="downloadCSVColumns"
				[downloadcsvorderby]="downloadCSVOrderBy"
			>
			</app-datatable-v3>
		</div>

		<!--
		Making display: none, as we don't need FQ-17247
		-->
		<div style="display: none;">
			<div class="card card1 mLeft" #chartcontainer (window:resize)="onResize($event)">
				<app-loader [showLoader]="showLoad"></app-loader>
				<div class="c-portlet__header">
					<div class="o-stack__cell">
						<h5>Engagements</h5>
					</div>
				</div>
				<app-donut [chartData]="seriesData" [chartConfigurationObj]="chartConfigObj"></app-donut>
				<div class="no-data-container" *ngIf="!hasData">
					<div class="map-no-data">No Data to Display</div>
				</div>
			</div>
		</div>
	</div>
</div>
